import { render, staticRenderFns } from "./aptEntrustProtocol.vue?vue&type=template&id=55d86431&scoped=true"
import script from "./aptEntrustProtocol.vue?vue&type=script&lang=js"
export * from "./aptEntrustProtocol.vue?vue&type=script&lang=js"
import style0 from "./aptEntrustProtocol.vue?vue&type=style&index=0&id=55d86431&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d86431",
  null
  
)

export default component.exports